import { render, staticRenderFns } from "./MeterialImport.vue?vue&type=template&id=9829698a"
import script from "./MeterialImport.vue?vue&type=script&lang=js"
export * from "./MeterialImport.vue?vue&type=script&lang=js"
import style0 from "./MeterialImport.vue?vue&type=style&index=0&id=9829698a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports